import { render, staticRenderFns } from "./formChangePassWord.vue?vue&type=template&id=68d6c32d&scoped=true&"
import script from "./formChangePassWord.vue?vue&type=script&lang=js&"
export * from "./formChangePassWord.vue?vue&type=script&lang=js&"
import style0 from "./formChangePassWord.vue?vue&type=style&index=0&id=68d6c32d&lang=scss&scoped=true&"
import style1 from "./formChangePassWord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d6c32d",
  null
  
)

export default component.exports